import React from 'react';
import { ReactComponent as BatteryIcon } from '../../assets/images/icons/compare_battery.svg';
import { ReactComponent as CallbackIcon } from '../../assets/images/icons/compare_callback.svg';
import { ReactComponent as CatIcon } from '../../assets/images/icons/compare_cat.svg';
import { ReactComponent as DogIcon } from '../../assets/images/icons/compare_dog.svg';
import { ReactComponent as HealthIcon } from '../../assets/images/icons/compare_health.svg';
import { ReactComponent as LinkIcon } from '../../assets/images/icons/compare_link.svg';
import { ReactComponent as AdventureIcon } from '../../assets/images/icons/compare_sec_adventure.svg';
import { ReactComponent as DeviceIcon } from '../../assets/images/icons/compare_sec_device.svg';
import { ReactComponent as TrackingIcon } from '../../assets/images/icons/compare_sec_tracking.svg';
import { ReactComponent as ShieldIcon } from '../../assets/images/icons/compare_shield.svg';

// Shared app icons, re-exported so CompareV2 consumers import all icons from here.
export { ReactComponent as CheckIcon } from '../../assets/images/icons/check_green.svg';
export { ReactComponent as CrossIcon } from '../../assets/images/icons/close_dimmed.svg';
export { ReactComponent as ChevronDownIcon } from '../../assets/images/icons/chevron_icon.svg';

export type ReasonIconName = 'dog' | 'link' | 'health' | 'shield' | 'battery' | 'callback' | 'cat';
export type SectionIconName = 'tracking' | 'health' | 'device' | 'adventure';

const REASON_ICONS: Record<ReasonIconName, typeof DogIcon> = {
  dog: DogIcon,
  link: LinkIcon,
  health: HealthIcon,
  shield: ShieldIcon,
  battery: BatteryIcon,
  callback: CallbackIcon,
  cat: CatIcon,
};

const SECTION_ICONS: Record<SectionIconName, typeof DogIcon> = {
  tracking: TrackingIcon,
  health: HealthIcon,
  device: DeviceIcon,
  adventure: AdventureIcon,
};

/** "Top reasons to buy" icon (inherits color via currentColor; sized by the parent's `& svg`). */
export const ReasonIcon: React.FC<{ name: ReasonIconName }> = ({ name }) => {
  const Icon = REASON_ICONS[name];
  return Icon ? <Icon aria-hidden /> : null;
};

/** Category-header icon (inherits color via currentColor; sized by the parent's `& svg`). */
export const SectionIcon: React.FC<{ name: SectionIconName }> = ({ name }) => {
  const Icon = SECTION_ICONS[name];
  return Icon ? <Icon aria-hidden /> : null;
};
